import { complementColor } from '../../shared/helpers/commons';

const transitionsDisabled = ['installed', 'accomplished'];

const statusesStates = {
    uninstallations: {
        "pending": 0,
        "coordination": 2,
        "scheduled": 4,
        "accomplished": 2,
        "validated": 4,
        "canceled": 4
    },
    maintenance: {
        "pending": 0,
        "coordination": 2,
        "scheduled": 4,
        "accomplished": 2,
        "validated": 4,
        "canceled": 4
    },
    installations: {
        "pending": 0,
        "verification": 1,
        "coordination": 3,
        "scheduled": 4,
        "installed": 1,
        "validated": 2,
        "finished": 4,
        "failed": 4,
        "reschedule": 2,
        "canceled": 4
    }
};

export const buildStatuses = (statuses, type) => statuses.map(status => buildStatus(status, type));

export const buildStatus = (status, type) => ({
    ...status,
    fontColor: complementColor(status.color),
    dictKey: `statuses:${status.name.toLowerCase()}`,
    colorStepAmount: statusesStates[type][status.name.toLowerCase()]
});
export const buildTransitions = (transitions = [], type) =>
    transitions
        .filter(transition => transitionsDisabled.indexOf(transition.nextStatus.name.toLowerCase()) === -1)
        .map(transition => buildStatus(transition.nextStatus, type));
